// src/redux-saga/actions/agentActionTypes.js

export const FETCH_AGENTS_REQUEST = 'FETCH_AGENTS_REQUEST';
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
export const FETCH_AGENTS_FAILURE = 'FETCH_AGENTS_FAILURE';

export const CREATE_AGENT_REQUEST = 'CREATE_AGENT_REQUEST';
export const CREATE_AGENT_SUCCESS = 'CREATE_AGENT_SUCCESS';
export const CREATE_AGENT_FAILURE = 'CREATE_AGENT_FAILURE';

export const UPDATE_AGENT_REQUEST = 'UPDATE_AGENT_REQUEST';
export const UPDATE_AGENT_SUCCESS = 'UPDATE_AGENT_SUCCESS';
export const UPDATE_AGENT_FAILURE = 'UPDATE_AGENT_FAILURE';

export const DELETE_AGENT_REQUEST = 'DELETE_AGENT_REQUEST';
export const DELETE_AGENT_SUCCESS = 'DELETE_AGENT_SUCCESS';
export const DELETE_AGENT_FAILURE = 'DELETE_AGENT_FAILURE';

// Action Creators for Fetching Agents
export const fetchAgentsRequest = ({ page = 1, limit = 10, search = '',model } = {}) => ({
  type: FETCH_AGENTS_REQUEST,
  payload: { page, limit, search,model },
});

export const fetchAgentsSuccess = (data) => ({
  type: FETCH_AGENTS_SUCCESS,
  payload: data,
});

export const fetchAgentsFailure = (error) => ({
  type: FETCH_AGENTS_FAILURE,
  payload: error,
});

// Action Creators for Creating Agents
export const createAgentRequest = (agentData) => ({
  type: CREATE_AGENT_REQUEST,
  payload: agentData,
});

export const createAgentSuccess = (data) => ({
  type: CREATE_AGENT_SUCCESS,
  payload: data,
});

export const createAgentFailure = (error) => ({
  type: CREATE_AGENT_FAILURE,
  payload: error,
});

// Action Creators for Updating Agents
export const updateAgentRequest = (agentId, agentData) => ({
  type: UPDATE_AGENT_REQUEST,
  payload: { agentId, agentData },
});

export const updateAgentSuccess = (data) => ({
  type: UPDATE_AGENT_SUCCESS,
  payload: data,
});

export const updateAgentFailure = (error) => ({
  type: UPDATE_AGENT_FAILURE,
  payload: error,
});

// Action Creators for Deleting Agents
export const deleteAgentRequest = (agentId) => ({
  type: DELETE_AGENT_REQUEST,
  payload: agentId,
});

export const deleteAgentSuccess = (agentId) => ({
  type: DELETE_AGENT_SUCCESS,
  payload: agentId,
});

export const deleteAgentFailure = (error) => ({
  type: DELETE_AGENT_FAILURE,
  payload: error,
});
